import request from '@/utils/request';
export const defaultCountryData = {
  id: 0,
  enabled: true,
  code: '',
  name: '',
  zipCodeMinLength: 0,
  zipCodeMaxLength: 0
};
export const getCountries = params => request({
  url: '/countries',
  method: 'get',
  params
});
export const getCountryById = id => request({
  url: `/countries/${id}`,
  method: 'get'
});
export const updateCountry = (id, data) => request({
  url: `/countries/${id}`,
  method: 'patch',
  data
});
export const deleteCountry = id => request({
  url: `/countries/${id}`,
  method: 'delete'
});
export const createCountry = data => request({
  url: '/countries/',
  method: 'post',
  data
});